export enum AlignableVariant {
  CARD = 'card',
  CHIP = 'chip',
}

export enum NudgeProfile {
  SPREAD = 'spread',
  STACK = 'stack',
}

export enum AlignableCardTag {
  DIV = 'div',
  ARTICLE = 'article',
  ASIDE = 'aside',
}

export enum AlignChipFieldTag {
  DIV = 'div',
  UL = 'ul',
}

export enum SkillChipTag {
  LI = 'li',
  SPAN = 'span',
}
